module.exports = __webpack_public_path__ + "img/info-01.de34aa3a.jpg";